import { Document, Font, Image, Link, Page, Path, StyleSheet, Svg, Text, View } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import QRCode from 'qrcode';
import iconLogo from '../../../assets/images/ic-logo-carlink.png';
import iconRight from '../../../assets/images/ic-right.png';
import iconLeft from '../../../assets/images/icon-left.png';
import { convertMinutes, convertTimeFormat, formatDate, formattedPrice } from '../../../lib/utils';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf', fontWeight: 300 },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
      fontWeight: 400,
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
      fontWeight: 500,
    },
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf', fontWeight: 600 },
  ],
});
// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#F0F0F0',
    fontFamily: 'Roboto',
  },
  textWarn: {
    fontWeight: 500,
    fontSize: 12,
    color: '#F8B507',
  },
  textInsurance: {
    fontWeight: 500,
    fontSize: 12,
    color: '#3AB54A',
  },
  locationText: {
    fontSize: 14,
    fontWeight: 600,
    color: '#3A3A3A',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: 16,
  },
  iconBus: {
    width: 90,
  },
  pageBackground: {
    position: 'absolute',
    minWidth: '100%',
    minHeight: '100%',
    height: '100%',
    width: '100%',
  },

  title: {
    marginTop: 15,
  },
  qrPayBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: 20,
    color: '#435869',
  },

  textNormal: {
    fontSize: 12,
    fontWeight: 500,
  },
  textCode: {
    fontSize: 15,
    color: '#3AB54A',
    fontWeight: 700,
  },
  qrpay: {
    width: 100,
    height: 105,
  },
  container: {
    padding: '12px 12px',
    fontFamily: 'Roboto',
  },
  containerPage2: {
    padding: 26,
  },
  w76: {
    width: 80,
  },
  w30: {
    width: 30,
  },
  text: {
    fontSize: 9,
    fontWeight: 500,
    color: '#435869',
  },
  textXs: {
    fontSize: 8,
    fontWeight: 500,
    color: '#435869',
  },
  logo: {
    height: 33,
    objectFit: 'contain',
  },
  qrCode: {
    width: 120,
    height: 135,
  },
  blockCode: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerBooking: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 16,
    columnGap: 14,
    margin: 2,
  },
  fw600: {
    fontWeight: 600,
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15,
  },
  textBlue: {
    color: '#435869',
  },
  textBlack: {
    color: '#3A3A3A',
  },
  fw500: {
    fontWeight: 500,
  },
  fw400: {
    fontWeight: 400,
  },
  fs14: {
    fontSize: 14,
  },
  fs12: {
    fontSize: 12,
  },
  fs16: {
    fontSize: 16,
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  lh22: {
    lineHeight: 20,
  },
  gap4: {
    columnGap: 4,
  },
  iconBusBlock: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: 4,
  },

  gap12: {
    columnGap: 5,
  },
  mta10: {
    marginTop: -5,
  },
  flexStart: {
    justifyContent: 'flex-start',
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  cardContent: {
    padding: 8,
  },
  blockTicket: {
    width: 251,
    height: 128,
    borderRadius: 4,
    border: '1px solid #DCDCDC',
    columnGap: 15,
    marginTop: 8,
    display: 'flex',
    marginRight: 10,
  },
  addressTicket: {
    paddingLeft: 4,
    borderLeft: '1px solid #435869',
    minHeight: 22,
  },
  mh100: {
    height: 50,
  },
  mt2: {
    marginTop: 5,
  },
  mt3: {
    marginTop: 3,
  },
  mt5: {
    marginTop: 5,
  },
  pr5: {
    paddingRight: 8,
  },
  mt10: {
    marginTop: 18,
  },
  ml6: {
    marginLeft: 6,
  },
  bgSeatNoBooking: {
    backgroundColor: '#DCDCDC',
  },
  h158: {
    height: 158,
  },
  mt20: {
    marginTop: 15,
  },
  w40: {
    width: '40%',
  },
  w60: {
    width: '60%',
  },
  w15: {
    width: '20%',
  },
  titleTicket: {
    color: '#949494',
    fontSize: 14,
    fontWeight: 400,
  },
  contentTicket: {
    fontSize: 14,
    color: '#435869',
    fontWeight: 500,
  },
  hourLocation: {
    fontSize: 12,
    color: '#435869',
    fontWeight: 500,
  },
  mauto: {
    margin: '0 auto',
  },
  blockAddress: {
    paddingBottom: 16,
    borderBottom: '1px solid #F0F0F0',
  },
  fw700: {
    fontWeight: 700,
  },
  mb: {
    marginBottom: 23,
  },
  ml8: {
    marginLeft: 8,
  },
  text1: {
    fontSize: 13,
    paddingBottom: 4,
    borderBottom: '2px solid #3AB54A',
    fontWeight: 500,
  },
  flexCenter: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  text2: {
    fontWeight: 400,
    fontSize: 11,
  },
  textBold: {
    fontWeight: 600,
    fontSize: 11,
    lineHeight: '2px',
  },
  textSemi: {
    fontWeight: 500,
    fontSize: 11,
  },
  textValue: {
    fontWeight: 500,
    fontSize: 11,
    color: '#647C8F',
    marginTop: 2,
    lineHeight: '2px',
  },
  textValue1: {
    fontWeight: 500,
    fontSize: 11,
    color: '#647C8F',
  },
  fs10: {
    fontSize: 10,
  },
  mt7: {
    marginTop: 4,
  },
  mt6: {
    marginTop: 4,
  },
  arriveBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  mt21: {
    marginTop: 21,
  },
  titleContract: {
    paddingLeft: 9,
    borderLeft: '4px solid #3AB54A',
  },
  pl17: {
    paddingLeft: 14,
  },
  titleHead: {
    paddingRight: 14,
    borderRight: '1px solid #BBBBBB',
    display: 'flex',
    alignItems: 'center',
  },
  dFlex: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '14px',
    alignItems: 'center',
  },
  dflex2: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 8,
    alignItems: 'center',
  },
  mt16: {
    marginTop: 12,
  },
  button: {
    width: 320,
    height: 28,
    marginRight: 20,
    backgroundColor: '#E8EDF1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#374A5E',
    fontSize: 13,
    fontWeight: 700,
  },
  mt40: {
    marginTop: 40,
  },
  blockHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingBottom: 16,
    borderBottom: '1px solid #F0F0F0',
  },
  blockQr: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  t1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 5,
    fontWeight: 500,
    color: '#647C8F',
    maxHeight: 50,
  },
  t2: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 50,
    fontSize: 13,
    fontWeight: 400,
    marginTop: 10,
    color: '#435869',
  },
  mt28: {
    marginTop: 28,
  },
  fs22: {
    fontSize: 22,
  },
  fs20: {
    fontSize: 20,
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  scheduleBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 4,
    columnGap: 70,
    fontSize: 12,
  },
  gray: {
    color: '#647C8F',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  hour: {
    fontSize: 12,
    color: '#435869',
    fontWeight: 500,
    marginTop: -3,
  },
  busType: {
    fontSize: 13,
    color: '#435869',
    fontWeight: 400,
  },
  p1: {
    color: '#435869',
    fontSize: 13,
  },
  p2: {
    color: '#647C8F',
    fontSize: 13,
  },
  blockP1: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 15,
  },
  mw30: {
    width: 130,
    display: 'flex',
    flexDirection: 'row',
    columnGap: 15,
  },
  borderP1: {
    paddingBottom: 22,
    borderBottom: '1px solid #647C8F',
    borderStyle: 'dashed',
  },
  mt24: {
    marginTop: 24,
  },
  green: {
    color: '#3AB54A',
    fontSize: 13,
    fontWeight: 500,
  },
  logoCarlink: {
    width: 16,
    height: 16,
  },
  warning: {
    fontWeight: 400,
    color: '#D81717',
    fontSize: 11,
  },
  footer: {
    color: '#949494',
    fontWeight: 400,
    fontSize: 14,
    margin: '0 auto',
    display: 'flex',
    marginTop: 7,
  },
  pb: {
    paddingBottom: 14,
    borderBottom: '1px solid #F0F0F0',
  },
});

export const DocumentTicket = ({
  listBooking,
  listBookingDetail,
  dataCustomerBooking,
  listOrder,
  isOrder,
  group,
  dataPrintTicket,
}: any) => {
  const qrValue = {
    ticket_code: listBookingDetail?.ticket_code,
    seat_number: listBookingDetail?.seat_number,
  };
  const QRCodeImage = (props: { url: string }) => {
    const urlPromise = QRCode.toDataURL(props.url);
    return <Image src={urlPromise} />;
  };

  const renderQr = (src: string) => {
    if (src) {
      return <Image src={src} style={styles.qrpay}></Image>;
    }
  };
  const removeDiacritics = (str: string) => {
    return str?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '');
  };

  const convertName = (name: string) => {
    const nameWithoutDiacritics = removeDiacritics(name);
    return nameWithoutDiacritics?.toUpperCase()?.replace(/\s/g, '');
  };
  const convertPrice = (price: string) => {
    return price?.replace(/,/g, '');
  };
  const getArriveDate = () => {
    if (listBooking?.schedule?.arrive_date) {
      return `${listBooking?.schedule?.arrive_date}`;
    }
    if (dataCustomerBooking?.depart_date) {
      return `${dayjs(dataCustomerBooking?.depart_date)
        ?.add(listBookingDetail?.drop_off_location?.diff_day, 'day')
        .format('DD/MM/YYYY')}`;
    }
    if (isOrder && listOrder?.depart_date) {
      return `${dayjs(listOrder?.depart_date)
        ?.add(listOrder?.drop_off_location?.diff_day, 'day')
        .format('DD/MM/YYYY')}`;
    } else {
      return '';
    }
  };
  const getDepartDate = () => {
    if (listBooking?.schedule?.depart_date) {
      return `${listBooking?.schedule?.depart_date}`;
    }
    if (dataCustomerBooking?.depart_date) {
      return `${dayjs(dataCustomerBooking?.depart_date)
        ?.add(listBookingDetail?.pickup_location?.diff_day, 'day')
        .format('DD/MM/YYYY')}`;
    }
    if (isOrder && listOrder?.depart_date) {
      return `${dayjs(listOrder?.depart_date)?.add(listOrder?.pickup_location?.diff_day, 'day').format('DD/MM/YYYY')}`;
    } else {
      return '';
    }
  };
  const getInsuranceFee = () => {
    if (listBookingDetail?.is_insurance) {
      return (
        <Text style={styles.textInsurance}>
          {`Giá trên đã bao gồm ${formattedPrice(listBookingDetail?.insurance_fee)}đ tiền bảo hiểm`}
        </Text>
      );
    }
    if (listOrder?.is_insurance) {
      return (
        <Text style={styles.textInsurance}>
          {listOrder?.display_price
            ? `Giá trên đã bao gồm ${formattedPrice(listOrder?.insurance_fee)}đ tiền bảo hiểm`
            : 'Vé đã bao gồm bảo hiểm chuyến đi.'}
        </Text>
      );
    }
  };
  const getInsuranceFeeMulti = (ticket: any) => {
    if (ticket?.is_insurance) {
      return (
        <Text style={styles.textInsurance}>
          {`Giá trên đã bao gồm ${formattedPrice(ticket?.insurance_fee)}đ tiền bảo hiểm`}
        </Text>
      );
    }
  };
  const convertTimeBus = (time: any) => {
    if (!time) {
      return '';
    } else {
      return time.replace(':', 'h');
    }
  };
  return (
    <>
      <Document>
        {dataPrintTicket?.length ? (
          dataPrintTicket?.map((ticket: any) => (
            <Page size={[302, 841.89]} key={ticket?.id}>
              <View style={styles.container}>
                <View style={[styles.blockHeader]}>
                  <View style={styles.blockQr}>
                    {!isOrder ? (
                      <View>
                        {listBooking?.schedule?.logo_company && (
                          <Image src={`${listBooking?.schedule?.logo_company}`} style={styles.logo} />
                        )}
                      </View>
                    ) : (
                      ''
                    )}
                  </View>
                </View>
                <View>
                  <Text style={[styles.fs16, styles.fw600, styles.textCenter]}>{ticket?.company?.name}</Text>
                </View>
                <View style={styles.blockCode}>
                  <View style={styles.qrCode}>
                    <QRCodeImage url={JSON.stringify(qrValue)} />
                  </View>
                  <View style={[styles.flex, styles.gap12, styles.mta10]}>
                    <Svg width="14" height="12" viewBox="0 0 14 12" fill="none">
                      <Path
                        d="M15.8181 5.66875L14.439 4.28969C14.3277 4.17992 14.1794 4.11583 14.0232 4.11005C13.867 4.10426 13.7143 4.1572 13.5953 4.25844C13.4114 4.41492 13.1755 4.49662 12.9343 4.48736C12.693 4.4781 12.4641 4.37855 12.2928 4.20844C12.1227 4.03715 12.0232 3.80825 12.014 3.56709C12.0047 3.32592 12.0864 3.09007 12.2428 2.90625C12.344 2.78717 12.3969 2.63449 12.3911 2.4783C12.3854 2.32211 12.3213 2.17376 12.2115 2.0625L10.8312 0.681874C10.7145 0.565449 10.5565 0.500061 10.3917 0.500061C10.2268 0.500061 10.0688 0.565449 9.95213 0.681874L7.75369 2.88C7.61798 3.01624 7.51563 3.18202 7.45463 3.36437C7.44275 3.39944 7.42296 3.43129 7.39678 3.45747C7.37061 3.48365 7.33875 3.50344 7.30369 3.51531C7.12125 3.5763 6.95545 3.67878 6.81931 3.81469L1.18181 9.45219C1.06539 9.56884 1 9.72691 1 9.89172C1 10.0565 1.06539 10.2146 1.18181 10.3312L2.56244 11.7103C2.6737 11.8201 2.82205 11.8842 2.97824 11.89C3.13442 11.8957 3.28711 11.8428 3.40619 11.7416C3.58959 11.5838 3.82583 11.5012 4.06757 11.5103C4.30931 11.5194 4.53869 11.6195 4.70974 11.7905C4.8808 11.9616 4.98089 12.1909 4.98997 12.4327C4.99905 12.6744 4.91643 12.9107 4.75869 13.0941C4.65746 13.2131 4.60451 13.3658 4.6103 13.522C4.61608 13.6782 4.68017 13.8265 4.78994 13.9378L6.169 15.3169C6.28565 15.4333 6.44372 15.4987 6.60853 15.4987C6.77334 15.4987 6.93141 15.4333 7.04806 15.3169L12.6856 9.67937C12.8214 9.54333 12.9239 9.37764 12.9849 9.19531C12.9968 9.16013 13.0166 9.12817 13.0428 9.10193C13.069 9.07569 13.101 9.05588 13.1362 9.04406C13.3185 8.98308 13.4841 8.88072 13.6203 8.745L15.8184 6.54656C15.9344 6.42992 15.9995 6.27209 15.9994 6.10759C15.9994 5.94309 15.9341 5.7853 15.8181 5.66875ZM8.6815 4.74219C8.63507 4.78863 8.57995 4.82547 8.51927 4.8506C8.4586 4.87574 8.39358 4.88867 8.32791 4.88867C8.26224 4.88867 8.19721 4.87574 8.13654 4.8506C8.07587 4.82547 8.02074 4.78863 7.97431 4.74219L7.61463 4.3825C7.52314 4.28826 7.47241 4.1618 7.4734 4.03047C7.47439 3.89913 7.52702 3.77345 7.61991 3.6806C7.7128 3.58775 7.8385 3.53517 7.96984 3.53424C8.10118 3.53331 8.22761 3.5841 8.32181 3.67562L8.6815 4.035C8.72794 4.08143 8.76478 4.13655 8.78992 4.19722C8.81505 4.25789 8.82799 4.32292 8.82799 4.38859C8.82799 4.45426 8.81505 4.51929 8.78992 4.57996C8.76478 4.64063 8.72794 4.69576 8.6815 4.74219ZM10.0565 6.11719C9.96274 6.21088 9.83561 6.26352 9.70306 6.26352C9.57051 6.26352 9.44338 6.21088 9.34963 6.11719L9.00588 5.77344C8.9121 5.67966 8.85941 5.55247 8.85941 5.41984C8.85941 5.28722 8.9121 5.16003 9.00588 5.06625C9.09965 4.97247 9.22685 4.91979 9.35947 4.91979C9.49209 4.91979 9.61928 4.97247 9.71306 5.06625L10.0568 5.41C10.1034 5.45643 10.1404 5.51159 10.1656 5.57234C10.1909 5.63308 10.2039 5.69821 10.2039 5.764C10.204 5.82978 10.191 5.89492 10.1658 5.95569C10.1406 6.01646 10.1037 6.07166 10.0571 6.11812L10.0565 6.11719ZM11.4315 7.49219C11.3851 7.53863 11.3299 7.57547 11.2693 7.6006C11.2086 7.62574 11.1436 7.63867 11.0779 7.63867C11.0122 7.63867 10.9472 7.62574 10.8865 7.6006C10.8259 7.57547 10.7707 7.53863 10.7243 7.49219L10.3806 7.14844C10.2891 7.0542 10.2383 6.92774 10.2393 6.7964C10.2403 6.66506 10.293 6.53939 10.3858 6.44654C10.4787 6.35368 10.6044 6.30111 10.7358 6.30018C10.8671 6.29925 10.9936 6.35003 11.0878 6.44156L11.4315 6.78531C11.4782 6.83166 11.5154 6.88678 11.5407 6.94751C11.5661 7.00824 11.5793 7.07339 11.5794 7.13921C11.5795 7.20503 11.5667 7.27023 11.5416 7.33107C11.5165 7.39191 11.4796 7.44719 11.4331 7.49375L11.4315 7.49219ZM12.8199 8.88406C12.7735 8.9305 12.7184 8.96734 12.6577 8.99248C12.597 9.01761 12.532 9.03055 12.4663 9.03055C12.4007 9.03055 12.3356 9.01761 12.275 8.99248C12.2143 8.96734 12.1592 8.9305 12.1128 8.88406L11.7553 8.52469C11.7078 8.47839 11.6701 8.42314 11.6442 8.36213C11.6184 8.30112 11.6049 8.23558 11.6045 8.16931C11.6042 8.10304 11.6171 8.03737 11.6424 7.97612C11.6677 7.91487 11.7049 7.85925 11.7518 7.81251C11.7988 7.76577 11.8546 7.72883 11.916 7.70384C11.9774 7.67885 12.0431 7.66631 12.1094 7.66695C12.1756 7.66758 12.2411 7.68139 12.302 7.70756C12.3629 7.73372 12.4179 7.77173 12.464 7.81937L12.8218 8.17844C12.8682 8.22489 12.905 8.28003 12.9302 8.34071C12.9553 8.40139 12.9682 8.46642 12.9681 8.53209C12.9681 8.59777 12.9551 8.66279 12.93 8.72345C12.9048 8.78411 12.868 8.83921 12.8215 8.88562L12.8199 8.88406Z"
                        fill="#3AB54A"
                      />
                    </Svg>

                    <Text style={styles.textCode}>{ticket?.ticket_code}</Text>
                    <Svg width="14" height="12" viewBox="0 0 14 12" fill="none">
                      <Path
                        d="M15.8181 5.66875L14.439 4.28969C14.3277 4.17992 14.1794 4.11583 14.0232 4.11005C13.867 4.10426 13.7143 4.1572 13.5953 4.25844C13.4114 4.41492 13.1755 4.49662 12.9343 4.48736C12.693 4.4781 12.4641 4.37855 12.2928 4.20844C12.1227 4.03715 12.0232 3.80825 12.014 3.56709C12.0047 3.32592 12.0864 3.09007 12.2428 2.90625C12.344 2.78717 12.3969 2.63449 12.3911 2.4783C12.3854 2.32211 12.3213 2.17376 12.2115 2.0625L10.8312 0.681874C10.7145 0.565449 10.5565 0.500061 10.3917 0.500061C10.2268 0.500061 10.0688 0.565449 9.95213 0.681874L7.75369 2.88C7.61798 3.01624 7.51563 3.18202 7.45463 3.36437C7.44275 3.39944 7.42296 3.43129 7.39678 3.45747C7.37061 3.48365 7.33875 3.50344 7.30369 3.51531C7.12125 3.5763 6.95545 3.67878 6.81931 3.81469L1.18181 9.45219C1.06539 9.56884 1 9.72691 1 9.89172C1 10.0565 1.06539 10.2146 1.18181 10.3312L2.56244 11.7103C2.6737 11.8201 2.82205 11.8842 2.97824 11.89C3.13442 11.8957 3.28711 11.8428 3.40619 11.7416C3.58959 11.5838 3.82583 11.5012 4.06757 11.5103C4.30931 11.5194 4.53869 11.6195 4.70974 11.7905C4.8808 11.9616 4.98089 12.1909 4.98997 12.4327C4.99905 12.6744 4.91643 12.9107 4.75869 13.0941C4.65746 13.2131 4.60451 13.3658 4.6103 13.522C4.61608 13.6782 4.68017 13.8265 4.78994 13.9378L6.169 15.3169C6.28565 15.4333 6.44372 15.4987 6.60853 15.4987C6.77334 15.4987 6.93141 15.4333 7.04806 15.3169L12.6856 9.67937C12.8214 9.54333 12.9239 9.37764 12.9849 9.19531C12.9968 9.16013 13.0166 9.12817 13.0428 9.10193C13.069 9.07569 13.101 9.05588 13.1362 9.04406C13.3185 8.98308 13.4841 8.88072 13.6203 8.745L15.8184 6.54656C15.9344 6.42992 15.9995 6.27209 15.9994 6.10759C15.9994 5.94309 15.9341 5.7853 15.8181 5.66875ZM8.6815 4.74219C8.63507 4.78863 8.57995 4.82547 8.51927 4.8506C8.4586 4.87574 8.39358 4.88867 8.32791 4.88867C8.26224 4.88867 8.19721 4.87574 8.13654 4.8506C8.07587 4.82547 8.02074 4.78863 7.97431 4.74219L7.61463 4.3825C7.52314 4.28826 7.47241 4.1618 7.4734 4.03047C7.47439 3.89913 7.52702 3.77345 7.61991 3.6806C7.7128 3.58775 7.8385 3.53517 7.96984 3.53424C8.10118 3.53331 8.22761 3.5841 8.32181 3.67562L8.6815 4.035C8.72794 4.08143 8.76478 4.13655 8.78992 4.19722C8.81505 4.25789 8.82799 4.32292 8.82799 4.38859C8.82799 4.45426 8.81505 4.51929 8.78992 4.57996C8.76478 4.64063 8.72794 4.69576 8.6815 4.74219ZM10.0565 6.11719C9.96274 6.21088 9.83561 6.26352 9.70306 6.26352C9.57051 6.26352 9.44338 6.21088 9.34963 6.11719L9.00588 5.77344C8.9121 5.67966 8.85941 5.55247 8.85941 5.41984C8.85941 5.28722 8.9121 5.16003 9.00588 5.06625C9.09965 4.97247 9.22685 4.91979 9.35947 4.91979C9.49209 4.91979 9.61928 4.97247 9.71306 5.06625L10.0568 5.41C10.1034 5.45643 10.1404 5.51159 10.1656 5.57234C10.1909 5.63308 10.2039 5.69821 10.2039 5.764C10.204 5.82978 10.191 5.89492 10.1658 5.95569C10.1406 6.01646 10.1037 6.07166 10.0571 6.11812L10.0565 6.11719ZM11.4315 7.49219C11.3851 7.53863 11.3299 7.57547 11.2693 7.6006C11.2086 7.62574 11.1436 7.63867 11.0779 7.63867C11.0122 7.63867 10.9472 7.62574 10.8865 7.6006C10.8259 7.57547 10.7707 7.53863 10.7243 7.49219L10.3806 7.14844C10.2891 7.0542 10.2383 6.92774 10.2393 6.7964C10.2403 6.66506 10.293 6.53939 10.3858 6.44654C10.4787 6.35368 10.6044 6.30111 10.7358 6.30018C10.8671 6.29925 10.9936 6.35003 11.0878 6.44156L11.4315 6.78531C11.4782 6.83166 11.5154 6.88678 11.5407 6.94751C11.5661 7.00824 11.5793 7.07339 11.5794 7.13921C11.5795 7.20503 11.5667 7.27023 11.5416 7.33107C11.5165 7.39191 11.4796 7.44719 11.4331 7.49375L11.4315 7.49219ZM12.8199 8.88406C12.7735 8.9305 12.7184 8.96734 12.6577 8.99248C12.597 9.01761 12.532 9.03055 12.4663 9.03055C12.4007 9.03055 12.3356 9.01761 12.275 8.99248C12.2143 8.96734 12.1592 8.9305 12.1128 8.88406L11.7553 8.52469C11.7078 8.47839 11.6701 8.42314 11.6442 8.36213C11.6184 8.30112 11.6049 8.23558 11.6045 8.16931C11.6042 8.10304 11.6171 8.03737 11.6424 7.97612C11.6677 7.91487 11.7049 7.85925 11.7518 7.81251C11.7988 7.76577 11.8546 7.72883 11.916 7.70384C11.9774 7.67885 12.0431 7.66631 12.1094 7.66695C12.1756 7.66758 12.2411 7.68139 12.302 7.70756C12.3629 7.73372 12.4179 7.77173 12.464 7.81937L12.8218 8.17844C12.8682 8.22489 12.905 8.28003 12.9302 8.34071C12.9553 8.40139 12.9682 8.46642 12.9681 8.53209C12.9681 8.59777 12.9551 8.66279 12.93 8.72345C12.9048 8.78411 12.868 8.83921 12.8215 8.88562L12.8199 8.88406Z"
                        fill="#3AB54A"
                      />
                    </Svg>
                  </View>
                </View>
                <View style={[styles.mt6, styles.blockAddress, styles.mt3]}>
                  <View style={[styles.flex, styles.gap4, styles.mt3]}>
                    <Svg width="12" height="10" viewBox="0 0 10 10">
                      <Path
                        d="M9.99944 7.45556V9.42C9.99951 9.56065 9.94622 9.6961 9.85034 9.799C9.75445 9.9019 9.62311 9.9646 9.48281 9.97445C9.24004 9.99111 9.04172 10 8.8884 10C3.97922 10 0 6.02056 0 1.11111C0 0.957778 0.00833287 0.759445 0.0255541 0.516667C0.0353994 0.376358 0.0980952 0.245006 0.200991 0.149116C0.303886 0.053226 0.439322 -6.3574e-05 0.579968 1.42544e-07H2.5443C2.61321 -6.96303e-05 2.67968 0.0254772 2.73081 0.071678C2.78193 0.117879 2.81406 0.181435 2.82095 0.25C2.83373 0.377778 2.8454 0.479445 2.85651 0.556667C2.96691 1.32718 3.19316 2.07657 3.52758 2.77944C3.58036 2.89056 3.54591 3.02333 3.44592 3.09444L2.2471 3.95111C2.98009 5.65914 4.34117 7.0203 6.04911 7.75333L6.90462 6.55667C6.93958 6.50778 6.9906 6.47271 7.04877 6.45758C7.10694 6.44246 7.16858 6.44823 7.22293 6.47389C7.92567 6.80773 8.67483 7.03343 9.44503 7.14333C9.52225 7.15444 9.62391 7.16611 9.75057 7.17889C9.81903 7.18591 9.88245 7.2181 9.92853 7.26921C9.97462 7.32033 9.99953 7.38673 9.99944 7.45556Z"
                        fill="#647C8F"
                      />
                    </Svg>
                    <Text style={[styles.textNormal, styles.textBlue]}>{ticket?.customer?.phone}</Text>
                  </View>
                  <View style={[styles.flex, styles.gap4, styles.mt5, styles.pr5]}>
                    <Svg width="12" height="10" viewBox="0 0 12 16">
                      <Path
                        d="M7 0.5C5.343 0.501843 3.75442 1.12329 2.58274 2.22801C1.41107 3.33274 0.751959 4.83054 0.750004 6.39286C0.74848 7.66951 1.19075 8.91146 2.00909 9.92857C2.00909 9.92857 2.17955 10.1402 2.20739 10.1707L7 15.5L11.7949 10.168C11.8199 10.1396 11.9909 9.92857 11.9909 9.92857L11.9915 9.92696C12.8093 8.91023 13.2513 7.6689 13.25 6.39286C13.248 4.83054 12.5889 3.33274 11.4173 2.22801C10.2456 1.12329 8.657 0.501843 7 0.5ZM7 8.53571C6.5505 8.53571 6.11109 8.41004 5.73734 8.17458C5.36359 7.93912 5.07229 7.60445 4.90028 7.21289C4.72826 6.82134 4.68325 6.39048 4.77094 5.97481C4.85864 5.55913 5.07509 5.17731 5.39294 4.87763C5.71079 4.57794 6.11575 4.37386 6.55661 4.29117C6.99748 4.20849 7.45445 4.25093 7.86973 4.41312C8.28502 4.5753 8.63997 4.84996 8.8897 5.20235C9.13943 5.55474 9.27273 5.96904 9.27273 6.39286C9.27197 6.96096 9.03229 7.50559 8.60623 7.9073C8.18017 8.30901 7.60253 8.53501 7 8.53571Z"
                        fill="#647C8F"
                      />
                    </Svg>
                    <Text style={[styles.textNormal, styles.textBlue]}>{ticket?.company?.address}</Text>
                  </View>
                </View>

                <View style={[styles.locationText]}>
                  <Text>{ticket?.start_location ?? ''}</Text>
                  <Text>{ticket?.end_location ?? ''}</Text>
                </View>
                <View style={[styles.mt5, styles.flex, styles.iconBusBlock]}>
                  <Image src={iconLeft} style={styles.iconBus} />
                  <Text style={[styles.mt6, styles.hour]}>{ticket?.time?.duration ? ticket?.time?.duration : ''}</Text>
                  <Image src={iconRight} style={styles.iconBus} />
                </View>
                <View style={styles.scheduleBlock}>
                  <View>
                    <Text style={[styles.fs20, styles.fw700]}>
                      {ticket?.time?.depart_time ? convertTimeFormat(ticket?.time?.depart_time) : ''}
                    </Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {ticket?.time?.depart_time ? formatDate(ticket?.time?.depart_date, 'DD/MM/YYYY') : ''}
                    </Text>
                  </View>
                  <View style={[styles.arriveBlock]}>
                    <Text style={[styles.fs20, styles.fw700, styles.ml8]}>
                      {ticket?.time?.arrive_time ? convertTimeFormat(ticket?.time?.arrive_time) : ''}
                    </Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {ticket?.time?.arrive_date ? formatDate(ticket?.time?.arrive_date, 'DD/MM/YYYY') : ''}
                    </Text>
                  </View>
                </View>
                <View style={[styles.flex, styles.mt5]}>
                  <Text style={[styles.fs12, styles.fw500]}> {`Loại xe: `}</Text>
                  <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>{ticket?.bus_type}</Text>
                </View>
                <View style={[styles.flex, styles.mt5]}>
                  <View style={[styles.flex, styles.w40]}>
                    <Text style={[styles.fs12, styles.fw500]}> {'Mã ghế: '}</Text>
                    <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>{` ${ticket?.seat_number ?? ''}`}</Text>
                  </View>
                  {ticket?.display_price ? (
                    <View style={[styles.flex, styles.w60, styles.flexEnd]}>
                      <Text style={[styles.fs12, styles.fw500]}> Tổng tiền: </Text>
                      <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>
                        {ticket?.price ? ` ${ticket?.price}VNĐ` : ' 0VNĐ'}
                      </Text>
                    </View>
                  ) : (
                    ''
                  )}
                </View>
                <View style={[styles.mt5, styles.pb]}>
                  {ticket?.insurance_fee && <View>{getInsuranceFeeMulti(ticket)}</View>}
                </View>
                <View style={[styles.mt7]}>
                  {ticket?.payment_method === 'reserve' && (
                    <Text style={styles.textWarn}>
                      {`Vui lòng thanh toán trước ${convertTimeFormat(
                        listBooking?.schedule?.depart_time,
                      )} -  ${formatDate(listBooking?.travel_info?.depart_date, 'DD/MM/YYYY')}.`}
                    </Text>
                  )}
                </View>
                <View style={styles.mt16}>
                  <Text style={[styles.fs12, styles.fw500]}>Hành khách:</Text>
                  <View style={[styles.flex, styles.fs14, styles.textBlue, styles.fw600, styles.mt3]}>
                    <Text>{ticket?.customer?.name ?? ''}</Text>
                    <View style={[styles.ml8, styles.flex]}>
                      <Svg width="12" height="10" viewBox="0 0 10 10">
                        <Path
                          d="M9.99944 7.45556V9.42C9.99951 9.56065 9.94622 9.6961 9.85034 9.799C9.75445 9.9019 9.62311 9.9646 9.48281 9.97445C9.24004 9.99111 9.04172 10 8.8884 10C3.97922 10 0 6.02056 0 1.11111C0 0.957778 0.00833287 0.759445 0.0255541 0.516667C0.0353994 0.376358 0.0980952 0.245006 0.200991 0.149116C0.303886 0.053226 0.439322 -6.3574e-05 0.579968 1.42544e-07H2.5443C2.61321 -6.96303e-05 2.67968 0.0254772 2.73081 0.071678C2.78193 0.117879 2.81406 0.181435 2.82095 0.25C2.83373 0.377778 2.8454 0.479445 2.85651 0.556667C2.96691 1.32718 3.19316 2.07657 3.52758 2.77944C3.58036 2.89056 3.54591 3.02333 3.44592 3.09444L2.2471 3.95111C2.98009 5.65914 4.34117 7.0203 6.04911 7.75333L6.90462 6.55667C6.93958 6.50778 6.9906 6.47271 7.04877 6.45758C7.10694 6.44246 7.16858 6.44823 7.22293 6.47389C7.92567 6.80773 8.67483 7.03343 9.44503 7.14333C9.52225 7.15444 9.62391 7.16611 9.75057 7.17889C9.81903 7.18591 9.88245 7.2181 9.92853 7.26921C9.97462 7.32033 9.99953 7.38673 9.99944 7.45556Z"
                          fill="#647C8F"
                        />
                      </Svg>
                      <Text style={[styles.textNormal]}>
                        {ticket?.customer?.phone ? ` ${ticket?.customer?.phone}` : ` ${ticket?.customer?.phone}`}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles.mt7]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm đón:</Text>
                    {ticket?.pickup_extra ||
                    !ticket?.pickup_location?.latitude ||
                    !ticket?.pickup_location?.longitude ? (
                      <>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {ticket?.pickup_location?.location_name ?? ticket?.pickup_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue, styles.mt2]}>
                          {ticket?.pickup_location?.address ?? ''}
                        </Text>
                      </>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${ticket?.pickup_location?.longitude},${ticket?.pickup_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.ml6]}>
                          {ticket?.pickup_location?.location_name ?? ticket?.pickup_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue, styles.mt2]}>
                          {ticket?.pickup_location?.address ?? ''}
                        </Text>
                      </Link>
                    )}
                    <Text style={[styles.hourLocation, styles.mt2]}>
                      {convertTimeFormat(ticket?.pickup_location?.time)
                        ? ` ${convertTimeFormat(ticket?.pickup_location?.time)} - ${getDepartDate()}`
                        : ` ${convertTimeFormat(ticket?.schedule?.depart_time)}- ${getDepartDate()}`}
                    </Text>
                  </View>
                  <View style={[styles.mt5]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm trả:</Text>
                    {ticket?.drop_off_extra ||
                    !ticket?.drop_off_location?.latitude ||
                    !ticket?.drop_off_location?.longitude ? (
                      <>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {ticket?.drop_off_location?.location_name ?? ticket?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {ticket?.drop_off_location?.address ? `${ticket?.drop_off_location?.address}` : ''}
                        </Text>
                      </>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${ticket?.drop_off_location?.longitude},${ticket?.drop_off_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {ticket?.drop_off_location?.location_name ?? ticket?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {ticket?.drop_off_location?.address ? `${ticket?.drop_off_location?.address}` : ''}
                        </Text>
                      </Link>
                    )}
                  </View>
                  <View style={[styles.mt5, styles.flex]}>
                    <Text style={[styles.hourLocation]}>
                      {convertTimeFormat(ticket?.drop_off_location?.time)
                        ? ` ${convertTimeFormat(ticket?.drop_off_location?.time)} - ${getArriveDate()}`
                        : ` ${convertTimeFormat(listBooking?.schedule?.arrive_time)}- ${getArriveDate()}`}
                    </Text>
                  </View>
                  <Text style={[styles.fs12, styles.mt7, styles.fw500, styles.pb]}>
                    {'Nhân viên in vé: '}
                    <Text style={[styles.fw600, styles.textBlue]}>{ticket?.orderer?.name}</Text>
                  </Text>
                </View>

                {(ticket?.payment_method === 'hold' ||
                  ticket?.payment_method === 'reserve' ||
                  ticket?.payment_method === 'paid_at_company') &&
                !isOrder ? (
                  <View style={styles.qrPayBlock}>
                    <>
                      <View>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlack]}>Thông tin thanh toán</Text>
                        <Text style={[styles.fs12, styles.fw500, styles.mt5]}>
                          Chủ TK:
                          <Text style={[styles.fw600, styles.fs12, styles.textBlue]}>
                            {listBooking?.schedule?.company?.bank_account_name ?? ticket?.company?.bank_account_name}
                          </Text>
                        </Text>
                        <Text style={[styles.fs12, styles.fw500, styles.mt5]}>
                          Số TK:
                          <Text style={[styles.fw600, styles.fs12, styles.textBlue]}>
                            {listBooking?.schedule?.company?.bank_account_number ??
                              ticket?.company?.bank_account_number}
                          </Text>
                        </Text>
                        <Text style={[styles.fs12, styles.fw500, styles.mt5]}>Nội dung chuyển khoản:</Text>
                        <Text style={[styles.fw600, styles.fs12, styles.textBlue, styles.mt5]}>{`  ${
                          ticket?.ticket_code
                        }  ${convertName(ticket?.customer?.name)}`}</Text>
                      </View>
                    </>
                    {listBooking?.schedule?.company?.bank && listBooking?.schedule?.company?.bank_account_number && (
                      <View>
                        {renderQr(
                          `https://img.vietqr.io/image/${listBooking?.schedule?.company?.bank}-${
                            listBooking?.schedule?.company?.bank_account_number
                          }-compact.jpg?amount=${convertPrice(ticket?.price)}&addInfo=${ticket?.customer?.name} - ${
                            ticket?.ticket_code
                          }`,
                        )}
                      </View>
                    )}
                  </View>
                ) : (
                  <View style={styles.mt16}>
                    {listBooking?.policy?.cancel_policy?.range?.length && (
                      <Text style={[styles.fs12, styles.fw600, styles.textBlack]}>Chính sách huỷ vé và hoàn trả:</Text>
                    )}
                    {listBooking?.policy?.cancel_policy?.range.map((policy: any, index: any) => {
                      if (index === 0) {
                        return (
                          <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                            Trong vòng {policy?.before_departure_hour} {'trước giờ khởi hành: '}
                            {policy?.cancel_fee_percent ?? 0}%
                          </Text>
                        );
                      } else {
                        const previousPolicy = listBooking?.policy?.cancel_policy?.range[index - 1];
                        return (
                          <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                            Từ {previousPolicy.before_departure_hour} - {policy.before_departure_hour}
                            {' tiếng trước giờ khởi hành: '} {policy?.cancel_fee_percent ?? 0}%
                          </Text>
                        );
                      }
                    })}
                    <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt16]}>
                      Mọi thao tác thay đổi, hoàn hủy vui lòng liên hệ
                    </Text>
                    <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                      đến số hotline nhà xe: .
                    </Text>
                  </View>
                )}
                <View style={[styles.footer]}>
                  <Text style={[styles.fs12, styles.fw500, styles.gray]}>Vé được xuất bởi hệ thống</Text>
                  <View style={[styles.flex, styles.flexCenter, styles.mt3]}>
                    <Image src={iconLogo} style={styles.logoCarlink} />
                    <Text style={[styles.fs12, styles.fw500, styles.green]}>{' carlink.com.vn'}</Text>
                  </View>
                </View>
              </View>
            </Page>
          ))
        ) : (
          <Page size={[302, 841.89]}>
            <View style={styles.container}>
              <View style={[styles.blockHeader]}>
                <View style={styles.blockQr}>
                  {!isOrder ? (
                    <View>
                      {listBooking?.schedule?.logo_company && (
                        <Image src={`${listBooking?.schedule?.logo_company}`} style={styles.logo} />
                      )}
                    </View>
                  ) : (
                    ''
                  )}
                  {isOrder && group !== 'car_company' ? (
                    <Svg width="100" height="22" viewBox="0 0 100 22" fill="none">
                      <Path
                        d="M16.7746 10.7238L15.1513 11.3071C16.7173 11.3071 17.2707 12.3392 17.3158 12.8777C17.3608 13.4162 17.5412 14.6726 15.1513 16.4675C12.7613 18.2625 8.11747 19.224 6.49341 19.3394L0 28C9.2569 25.6693 15.6924 22.4806 17.3608 21.4934C19.0293 20.5062 21.1938 18.9805 21.6447 17.9035C22.0956 16.8265 22.1407 15.4803 21.6447 14.1341C21.1487 12.7879 18.9842 10.9481 16.7746 10.7238Z"
                        fill="#3BB56C"
                      />
                      <Path
                        d="M19.4798 2.10912C18.6681 1.43602 15.5567 7.17881e-05 12.9864 7.17881e-05C10.4161 7.17881e-05 8.16144 -0.0447996 5.32058 2.10912C7.39486 1.39115 8.34182 0.942415 10.8219 0.942415C13.3021 0.942415 14.8352 1.79501 15.1509 2.6476C15.4665 3.50019 15.1509 4.84639 12.9864 5.96823C10.8219 7.09007 7.82705 7.64139 6.493 7.58367L2.16406 14.1352C13.1265 11.8841 19.2093 8.66064 20.2915 6.41697C21.3737 4.17329 20.2915 2.78222 19.4798 2.10912Z"
                        fill="#DCE68F"
                      />
                      <Path
                        d="M32 8.30176H34.6214C36.0981 8.30176 37.0793 8.55543 37.5653 9.06278C38.0513 9.57013 38.2943 10.1828 38.2943 10.9007C38.2943 11.3794 38.1915 11.8341 37.9859 12.2648C37.7803 12.686 37.4532 13.0019 37.0046 13.2125C37.6681 13.3848 38.1541 13.6864 38.4625 14.1171C38.7802 14.5479 38.9391 15.0553 38.9391 15.6392C38.9391 16.2518 38.8457 16.7879 38.6588 17.2474C38.4718 17.7069 38.084 18.0898 37.4952 18.3961C36.9065 18.7024 36.056 18.8556 34.9439 18.8556H32V8.30176ZM34.8738 12.7818C35.5373 12.7818 36.0093 12.619 36.2896 12.2936C36.57 11.9585 36.7102 11.5373 36.7102 11.03C36.7102 10.1206 36.0747 9.66586 34.8037 9.66586H33.542V12.7818H34.8738ZM35.1541 17.5059C36.0046 17.5059 36.5747 17.3336 36.8644 16.9889C37.1635 16.6347 37.313 16.1896 37.313 15.6536C37.313 15.1462 37.1448 14.7537 36.8083 14.4761C36.4719 14.1985 35.9625 14.0597 35.2803 14.0597H33.542V17.5059H35.1541Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M42.906 18.9992C42.0182 18.9992 41.406 18.7312 41.0696 18.1951C40.7425 17.659 40.579 16.9124 40.579 15.9551V12.2648H42.0929V15.5674C42.0929 16.113 42.121 16.539 42.1771 16.8453C42.2425 17.1421 42.364 17.3623 42.5415 17.5059C42.7284 17.6494 43.0041 17.7212 43.3686 17.7212C43.6303 17.7212 43.8826 17.6447 44.1256 17.4915C44.3686 17.3383 44.5649 17.1325 44.7144 16.8741C44.8733 16.606 44.9527 16.3141 44.9527 15.9982V12.2648H46.4527V18.8556H45.2191L45.0508 17.8936C44.8172 18.2669 44.5228 18.5445 44.1677 18.7264C43.8219 18.9083 43.4013 18.9992 42.906 18.9992Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M50.6815 18.9992C50.2329 18.9992 49.7657 18.9418 49.2797 18.8269C48.8031 18.7024 48.4619 18.5589 48.2563 18.3961L48.761 17.1756C49.3217 17.5777 49.9619 17.7787 50.6815 17.7787C51.4011 17.7787 51.7609 17.5633 51.7609 17.1325C51.7609 16.9411 51.6862 16.7927 51.5367 16.6874C51.3871 16.5821 51.1208 16.4577 50.7376 16.3141L50.2049 16.113C49.6442 15.8833 49.2002 15.6105 48.8732 15.2946C48.5461 14.9691 48.3825 14.5431 48.3825 14.0166C48.3825 13.4136 48.6115 12.9445 49.0694 12.6094C49.5367 12.2648 50.1582 12.0925 50.9339 12.0925C51.317 12.0925 51.6909 12.1356 52.0553 12.2218C52.4292 12.3079 52.7142 12.418 52.9105 12.552L52.3637 13.7869C52.2422 13.6624 52.046 13.5571 51.775 13.471C51.5133 13.3753 51.2189 13.3274 50.8918 13.3274C50.2283 13.3274 49.8965 13.5332 49.8965 13.9448C49.8965 14.1746 49.9853 14.3517 50.1628 14.4761C50.3404 14.591 50.6301 14.7202 51.032 14.8638C51.0694 14.8734 51.2142 14.926 51.4666 15.0218C52.0647 15.2611 52.5086 15.5339 52.7983 15.8402C53.088 16.1465 53.2329 16.539 53.2329 17.0177C53.2329 17.6686 52.9899 18.1616 52.5039 18.4966C52.0273 18.8317 51.4198 18.9992 50.6815 18.9992Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M58.618 18.9992C58.0947 18.9992 57.6227 18.87 57.2022 18.6115C56.791 18.3435 56.5059 18.0371 56.3471 17.6925L56.319 18.8556H54.8611V8.30176H56.3471V12.3653L56.277 13.4853C56.4358 13.1024 56.7442 12.777 57.2022 12.5089C57.6695 12.2313 58.1741 12.0925 58.7162 12.0925C59.3517 12.0925 59.9031 12.2409 60.3703 12.5377C60.847 12.8248 61.2115 13.2317 61.4638 13.7582C61.7161 14.2751 61.8423 14.8782 61.8423 15.5674C61.8423 16.2662 61.6928 16.8741 61.3937 17.391C61.104 17.9079 60.7115 18.3052 60.2161 18.5828C59.7302 18.8604 59.1975 18.9992 58.618 18.9992ZM58.3657 17.7069C58.9732 17.7069 59.4405 17.5106 59.7676 17.1182C60.0947 16.7161 60.2582 16.1992 60.2582 15.5674C60.2582 14.926 60.0947 14.4091 59.7676 14.0166C59.4498 13.6146 58.9825 13.4136 58.3657 13.4136C57.833 13.4136 57.3844 13.605 57.0199 13.9879C56.6555 14.3612 56.4732 14.8542 56.4732 15.4669V15.5674C56.4732 15.979 56.5573 16.3476 56.7256 16.673C56.9031 16.9985 57.1321 17.2522 57.4125 17.4341C57.7022 17.6159 58.0199 17.7069 58.3657 17.7069Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M66.457 18.9992C65.7934 18.9992 65.2047 18.846 64.6907 18.5397C64.1766 18.2334 63.7795 17.817 63.4991 17.2905C63.2187 16.764 63.0785 16.18 63.0785 15.5387C63.0785 14.9069 63.214 14.3277 63.4851 13.8012C63.7654 13.2747 64.1626 12.8583 64.6766 12.552C65.1906 12.2457 65.7841 12.0925 66.457 12.0925C67.1299 12.0925 67.7186 12.2457 68.2233 12.552C68.7373 12.8583 69.1298 13.2747 69.4008 13.8012C69.6812 14.3277 69.8214 14.9069 69.8214 15.5387C69.8214 16.18 69.6812 16.764 69.4008 17.2905C69.1205 17.817 68.7233 18.2334 68.2093 18.5397C67.7046 18.846 67.1205 18.9992 66.457 18.9992ZM66.499 17.7356C67.0411 17.7356 67.4663 17.5298 67.7747 17.1182C68.0925 16.7065 68.2513 16.1896 68.2513 15.5674C68.2513 14.9452 68.0831 14.4235 67.7467 14.0023C67.4102 13.5715 66.9663 13.3561 66.4149 13.3561C65.8822 13.3561 65.4523 13.5667 65.1252 13.9879C64.8075 14.4091 64.6486 14.9356 64.6486 15.5674C64.6486 16.18 64.8215 16.697 65.1673 17.1182C65.5131 17.5298 65.957 17.7356 66.499 17.7356Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M74.4382 18.9992C73.7746 18.9992 73.1859 18.846 72.6718 18.5397C72.1578 18.2334 71.7606 17.817 71.4803 17.2905C71.1999 16.764 71.0597 16.18 71.0597 15.5387C71.0597 14.9069 71.1952 14.3277 71.4663 13.8012C71.7466 13.2747 72.1438 12.8583 72.6578 12.552C73.1718 12.2457 73.7653 12.0925 74.4382 12.0925C75.1111 12.0925 75.6998 12.2457 76.2045 12.552C76.7185 12.8583 77.111 13.2747 77.382 13.8012C77.6624 14.3277 77.8026 14.9069 77.8026 15.5387C77.8026 16.18 77.6624 16.764 77.382 17.2905C77.1017 17.817 76.7045 18.2334 76.1905 18.5397C75.6858 18.846 75.1017 18.9992 74.4382 18.9992ZM74.4802 17.7356C75.0223 17.7356 75.4475 17.5298 75.7559 17.1182C76.0737 16.7065 76.2325 16.1896 76.2325 15.5674C76.2325 14.9452 76.0643 14.4235 75.7279 14.0023C75.3914 13.5715 74.9475 13.3561 74.3961 13.3561C73.8634 13.3561 73.4335 13.5667 73.1064 13.9879C72.7887 14.4091 72.6298 14.9356 72.6298 15.5674C72.6298 16.18 72.8027 16.697 73.1485 17.1182C73.4943 17.5298 73.9382 17.7356 74.4802 17.7356Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M85.2371 18.8556H83.4567L82.153 16.7018L81.7885 15.9694L80.9474 16.9028V18.8556H79.4895V8.30176H80.9334V14.0884L80.9054 15.2084L83.3586 12.2648H85.223L82.7979 15.0218L85.2371 18.8556Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M86.5545 12.2648H88.1245V18.8556H86.5545V12.2648ZM87.3255 11.03C87.0358 11.03 86.7928 10.9294 86.5965 10.7284C86.4003 10.5274 86.3021 10.2785 86.3021 9.98176C86.3021 9.71372 86.4003 9.48398 86.5965 9.29253C86.7928 9.10107 87.0358 9.00535 87.3255 9.00535C87.6059 9.00535 87.8442 9.10107 88.0404 9.29253C88.2367 9.48398 88.3348 9.71372 88.3348 9.98176C88.3348 10.2785 88.2367 10.5274 88.0404 10.7284C87.8535 10.9294 87.6152 11.03 87.3255 11.03Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M90.2207 12.2648H91.7067L91.7207 13.471C91.8983 13.0689 92.1786 12.7387 92.5618 12.4802C92.945 12.2218 93.3936 12.0925 93.9076 12.0925C94.5711 12.0925 95.0805 12.2361 95.4356 12.5233C95.7907 12.8009 96.029 13.1934 96.1505 13.7007C96.272 14.2081 96.3328 14.8686 96.3328 15.6823V18.8556H94.8188V15.7253C94.8188 14.8925 94.7393 14.2942 94.5805 13.9305C94.4216 13.5571 94.0945 13.3705 93.5992 13.3705C93.3188 13.3705 93.0338 13.4614 92.744 13.6433C92.4543 13.8156 92.2113 14.0693 92.0151 14.4043C91.8282 14.7394 91.7347 15.1318 91.7347 15.5818V18.8556H90.2207V12.2648Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M101.41 22.3018C100.934 22.3018 100.462 22.2347 99.9943 22.1007C99.5364 21.9667 99.2093 21.8423 99.013 21.7274L99.3495 20.2915C99.9663 20.7031 100.639 20.9089 101.368 20.9089C101.929 20.9089 102.401 20.7701 102.784 20.4925C103.167 20.2149 103.363 19.6741 103.373 18.87V17.6925C103.176 18.0659 102.859 18.377 102.42 18.6259C101.98 18.8747 101.494 18.9992 100.962 18.9992C100.401 18.9992 99.8868 18.8604 99.4196 18.5828C98.9523 18.2956 98.5831 17.8888 98.3121 17.3623C98.0411 16.8358 97.9056 16.2231 97.9056 15.5243C97.9056 14.8542 98.0317 14.2607 98.2841 13.7438C98.5457 13.2173 98.9149 12.8105 99.3915 12.5233C99.8681 12.2361 100.424 12.0925 101.06 12.0925C101.434 12.0925 101.784 12.1595 102.111 12.2936C102.438 12.4276 102.714 12.5951 102.938 12.7961C103.172 12.9876 103.326 13.179 103.401 13.3705L103.429 12.2648H104.859V18.8125C104.859 19.9325 104.578 20.7941 104.018 21.3971C103.457 22.0002 102.588 22.3018 101.41 22.3018ZM101.382 17.6925C101.915 17.6925 102.363 17.5059 102.728 17.1325C103.092 16.7496 103.275 16.2518 103.275 15.6392V15.5387C103.275 15.1271 103.191 14.7585 103.022 14.433C102.854 14.1076 102.625 13.8539 102.335 13.672C102.046 13.4901 101.728 13.3992 101.382 13.3992C100.784 13.3992 100.321 13.6002 99.9943 14.0023C99.6672 14.3947 99.5037 14.9069 99.5037 15.5387C99.5037 16.18 99.6625 16.7018 99.9803 17.1038C100.307 17.4963 100.775 17.6925 101.382 17.6925Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M107.837 18.9992C107.556 18.9992 107.318 18.9035 107.122 18.712C106.925 18.511 106.827 18.2669 106.827 17.9797C106.827 17.683 106.921 17.4389 107.108 17.2474C107.304 17.0464 107.547 16.9459 107.837 16.9459C108.126 16.9459 108.365 17.0464 108.551 17.2474C108.748 17.4389 108.846 17.683 108.846 17.9797C108.846 18.2669 108.748 18.511 108.551 18.712C108.365 18.9035 108.126 18.9992 107.837 18.9992Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M109.855 12.2648H111.58L112.967 15.2371L113.416 16.4289L113.865 15.2371L115.238 12.2648H116.921L113.542 18.8556H113.248L109.855 12.2648Z"
                        fill="#3D526C"
                      />
                      <Path
                        d="M117.888 12.2648H119.374L119.388 13.471C119.565 13.0689 119.846 12.7387 120.229 12.4802C120.612 12.2218 121.061 12.0925 121.575 12.0925C122.238 12.0925 122.748 12.2361 123.103 12.5233C123.458 12.8009 123.696 13.1934 123.818 13.7007C123.939 14.2081 124 14.8686 124 15.6823V18.8556H122.486V15.7253C122.486 14.8925 122.407 14.2942 122.248 13.9305C122.089 13.5571 121.762 13.3705 121.266 13.3705C120.986 13.3705 120.701 13.4614 120.411 13.6433C120.122 13.8156 119.879 14.0693 119.682 14.4043C119.495 14.7394 119.402 15.1318 119.402 15.5818V18.8556H117.888V12.2648Z"
                        fill="#3D526C"
                      />
                    </Svg>
                  ) : (
                    ''
                  )}
                </View>
              </View>
              <View>
                <Text style={[styles.fs16, styles.fw600, styles.textCenter]}>
                  {!isOrder
                    ? listBooking?.schedule?.company_info?.name ?? listBookingDetail?.company?.name
                    : listOrder?.company_name ?? listBookingDetail?.company?.name}
                </Text>
              </View>
              <View style={styles.blockCode}>
                <View style={styles.qrCode}>
                  <QRCodeImage url={JSON.stringify(qrValue)} />
                </View>
                <View style={[styles.flex, styles.gap12, styles.mta10]}>
                  <Svg width="14" height="12" viewBox="0 0 14 12" fill="none">
                    <Path
                      d="M15.8181 5.66875L14.439 4.28969C14.3277 4.17992 14.1794 4.11583 14.0232 4.11005C13.867 4.10426 13.7143 4.1572 13.5953 4.25844C13.4114 4.41492 13.1755 4.49662 12.9343 4.48736C12.693 4.4781 12.4641 4.37855 12.2928 4.20844C12.1227 4.03715 12.0232 3.80825 12.014 3.56709C12.0047 3.32592 12.0864 3.09007 12.2428 2.90625C12.344 2.78717 12.3969 2.63449 12.3911 2.4783C12.3854 2.32211 12.3213 2.17376 12.2115 2.0625L10.8312 0.681874C10.7145 0.565449 10.5565 0.500061 10.3917 0.500061C10.2268 0.500061 10.0688 0.565449 9.95213 0.681874L7.75369 2.88C7.61798 3.01624 7.51563 3.18202 7.45463 3.36437C7.44275 3.39944 7.42296 3.43129 7.39678 3.45747C7.37061 3.48365 7.33875 3.50344 7.30369 3.51531C7.12125 3.5763 6.95545 3.67878 6.81931 3.81469L1.18181 9.45219C1.06539 9.56884 1 9.72691 1 9.89172C1 10.0565 1.06539 10.2146 1.18181 10.3312L2.56244 11.7103C2.6737 11.8201 2.82205 11.8842 2.97824 11.89C3.13442 11.8957 3.28711 11.8428 3.40619 11.7416C3.58959 11.5838 3.82583 11.5012 4.06757 11.5103C4.30931 11.5194 4.53869 11.6195 4.70974 11.7905C4.8808 11.9616 4.98089 12.1909 4.98997 12.4327C4.99905 12.6744 4.91643 12.9107 4.75869 13.0941C4.65746 13.2131 4.60451 13.3658 4.6103 13.522C4.61608 13.6782 4.68017 13.8265 4.78994 13.9378L6.169 15.3169C6.28565 15.4333 6.44372 15.4987 6.60853 15.4987C6.77334 15.4987 6.93141 15.4333 7.04806 15.3169L12.6856 9.67937C12.8214 9.54333 12.9239 9.37764 12.9849 9.19531C12.9968 9.16013 13.0166 9.12817 13.0428 9.10193C13.069 9.07569 13.101 9.05588 13.1362 9.04406C13.3185 8.98308 13.4841 8.88072 13.6203 8.745L15.8184 6.54656C15.9344 6.42992 15.9995 6.27209 15.9994 6.10759C15.9994 5.94309 15.9341 5.7853 15.8181 5.66875ZM8.6815 4.74219C8.63507 4.78863 8.57995 4.82547 8.51927 4.8506C8.4586 4.87574 8.39358 4.88867 8.32791 4.88867C8.26224 4.88867 8.19721 4.87574 8.13654 4.8506C8.07587 4.82547 8.02074 4.78863 7.97431 4.74219L7.61463 4.3825C7.52314 4.28826 7.47241 4.1618 7.4734 4.03047C7.47439 3.89913 7.52702 3.77345 7.61991 3.6806C7.7128 3.58775 7.8385 3.53517 7.96984 3.53424C8.10118 3.53331 8.22761 3.5841 8.32181 3.67562L8.6815 4.035C8.72794 4.08143 8.76478 4.13655 8.78992 4.19722C8.81505 4.25789 8.82799 4.32292 8.82799 4.38859C8.82799 4.45426 8.81505 4.51929 8.78992 4.57996C8.76478 4.64063 8.72794 4.69576 8.6815 4.74219ZM10.0565 6.11719C9.96274 6.21088 9.83561 6.26352 9.70306 6.26352C9.57051 6.26352 9.44338 6.21088 9.34963 6.11719L9.00588 5.77344C8.9121 5.67966 8.85941 5.55247 8.85941 5.41984C8.85941 5.28722 8.9121 5.16003 9.00588 5.06625C9.09965 4.97247 9.22685 4.91979 9.35947 4.91979C9.49209 4.91979 9.61928 4.97247 9.71306 5.06625L10.0568 5.41C10.1034 5.45643 10.1404 5.51159 10.1656 5.57234C10.1909 5.63308 10.2039 5.69821 10.2039 5.764C10.204 5.82978 10.191 5.89492 10.1658 5.95569C10.1406 6.01646 10.1037 6.07166 10.0571 6.11812L10.0565 6.11719ZM11.4315 7.49219C11.3851 7.53863 11.3299 7.57547 11.2693 7.6006C11.2086 7.62574 11.1436 7.63867 11.0779 7.63867C11.0122 7.63867 10.9472 7.62574 10.8865 7.6006C10.8259 7.57547 10.7707 7.53863 10.7243 7.49219L10.3806 7.14844C10.2891 7.0542 10.2383 6.92774 10.2393 6.7964C10.2403 6.66506 10.293 6.53939 10.3858 6.44654C10.4787 6.35368 10.6044 6.30111 10.7358 6.30018C10.8671 6.29925 10.9936 6.35003 11.0878 6.44156L11.4315 6.78531C11.4782 6.83166 11.5154 6.88678 11.5407 6.94751C11.5661 7.00824 11.5793 7.07339 11.5794 7.13921C11.5795 7.20503 11.5667 7.27023 11.5416 7.33107C11.5165 7.39191 11.4796 7.44719 11.4331 7.49375L11.4315 7.49219ZM12.8199 8.88406C12.7735 8.9305 12.7184 8.96734 12.6577 8.99248C12.597 9.01761 12.532 9.03055 12.4663 9.03055C12.4007 9.03055 12.3356 9.01761 12.275 8.99248C12.2143 8.96734 12.1592 8.9305 12.1128 8.88406L11.7553 8.52469C11.7078 8.47839 11.6701 8.42314 11.6442 8.36213C11.6184 8.30112 11.6049 8.23558 11.6045 8.16931C11.6042 8.10304 11.6171 8.03737 11.6424 7.97612C11.6677 7.91487 11.7049 7.85925 11.7518 7.81251C11.7988 7.76577 11.8546 7.72883 11.916 7.70384C11.9774 7.67885 12.0431 7.66631 12.1094 7.66695C12.1756 7.66758 12.2411 7.68139 12.302 7.70756C12.3629 7.73372 12.4179 7.77173 12.464 7.81937L12.8218 8.17844C12.8682 8.22489 12.905 8.28003 12.9302 8.34071C12.9553 8.40139 12.9682 8.46642 12.9681 8.53209C12.9681 8.59777 12.9551 8.66279 12.93 8.72345C12.9048 8.78411 12.868 8.83921 12.8215 8.88562L12.8199 8.88406Z"
                      fill="#3AB54A"
                    />
                  </Svg>

                  <Text style={styles.textCode}>
                    {!isOrder ? listBookingDetail?.ticket_code : listOrder?.ticket_code}
                  </Text>
                  <Svg width="14" height="12" viewBox="0 0 14 12" fill="none">
                    <Path
                      d="M15.8181 5.66875L14.439 4.28969C14.3277 4.17992 14.1794 4.11583 14.0232 4.11005C13.867 4.10426 13.7143 4.1572 13.5953 4.25844C13.4114 4.41492 13.1755 4.49662 12.9343 4.48736C12.693 4.4781 12.4641 4.37855 12.2928 4.20844C12.1227 4.03715 12.0232 3.80825 12.014 3.56709C12.0047 3.32592 12.0864 3.09007 12.2428 2.90625C12.344 2.78717 12.3969 2.63449 12.3911 2.4783C12.3854 2.32211 12.3213 2.17376 12.2115 2.0625L10.8312 0.681874C10.7145 0.565449 10.5565 0.500061 10.3917 0.500061C10.2268 0.500061 10.0688 0.565449 9.95213 0.681874L7.75369 2.88C7.61798 3.01624 7.51563 3.18202 7.45463 3.36437C7.44275 3.39944 7.42296 3.43129 7.39678 3.45747C7.37061 3.48365 7.33875 3.50344 7.30369 3.51531C7.12125 3.5763 6.95545 3.67878 6.81931 3.81469L1.18181 9.45219C1.06539 9.56884 1 9.72691 1 9.89172C1 10.0565 1.06539 10.2146 1.18181 10.3312L2.56244 11.7103C2.6737 11.8201 2.82205 11.8842 2.97824 11.89C3.13442 11.8957 3.28711 11.8428 3.40619 11.7416C3.58959 11.5838 3.82583 11.5012 4.06757 11.5103C4.30931 11.5194 4.53869 11.6195 4.70974 11.7905C4.8808 11.9616 4.98089 12.1909 4.98997 12.4327C4.99905 12.6744 4.91643 12.9107 4.75869 13.0941C4.65746 13.2131 4.60451 13.3658 4.6103 13.522C4.61608 13.6782 4.68017 13.8265 4.78994 13.9378L6.169 15.3169C6.28565 15.4333 6.44372 15.4987 6.60853 15.4987C6.77334 15.4987 6.93141 15.4333 7.04806 15.3169L12.6856 9.67937C12.8214 9.54333 12.9239 9.37764 12.9849 9.19531C12.9968 9.16013 13.0166 9.12817 13.0428 9.10193C13.069 9.07569 13.101 9.05588 13.1362 9.04406C13.3185 8.98308 13.4841 8.88072 13.6203 8.745L15.8184 6.54656C15.9344 6.42992 15.9995 6.27209 15.9994 6.10759C15.9994 5.94309 15.9341 5.7853 15.8181 5.66875ZM8.6815 4.74219C8.63507 4.78863 8.57995 4.82547 8.51927 4.8506C8.4586 4.87574 8.39358 4.88867 8.32791 4.88867C8.26224 4.88867 8.19721 4.87574 8.13654 4.8506C8.07587 4.82547 8.02074 4.78863 7.97431 4.74219L7.61463 4.3825C7.52314 4.28826 7.47241 4.1618 7.4734 4.03047C7.47439 3.89913 7.52702 3.77345 7.61991 3.6806C7.7128 3.58775 7.8385 3.53517 7.96984 3.53424C8.10118 3.53331 8.22761 3.5841 8.32181 3.67562L8.6815 4.035C8.72794 4.08143 8.76478 4.13655 8.78992 4.19722C8.81505 4.25789 8.82799 4.32292 8.82799 4.38859C8.82799 4.45426 8.81505 4.51929 8.78992 4.57996C8.76478 4.64063 8.72794 4.69576 8.6815 4.74219ZM10.0565 6.11719C9.96274 6.21088 9.83561 6.26352 9.70306 6.26352C9.57051 6.26352 9.44338 6.21088 9.34963 6.11719L9.00588 5.77344C8.9121 5.67966 8.85941 5.55247 8.85941 5.41984C8.85941 5.28722 8.9121 5.16003 9.00588 5.06625C9.09965 4.97247 9.22685 4.91979 9.35947 4.91979C9.49209 4.91979 9.61928 4.97247 9.71306 5.06625L10.0568 5.41C10.1034 5.45643 10.1404 5.51159 10.1656 5.57234C10.1909 5.63308 10.2039 5.69821 10.2039 5.764C10.204 5.82978 10.191 5.89492 10.1658 5.95569C10.1406 6.01646 10.1037 6.07166 10.0571 6.11812L10.0565 6.11719ZM11.4315 7.49219C11.3851 7.53863 11.3299 7.57547 11.2693 7.6006C11.2086 7.62574 11.1436 7.63867 11.0779 7.63867C11.0122 7.63867 10.9472 7.62574 10.8865 7.6006C10.8259 7.57547 10.7707 7.53863 10.7243 7.49219L10.3806 7.14844C10.2891 7.0542 10.2383 6.92774 10.2393 6.7964C10.2403 6.66506 10.293 6.53939 10.3858 6.44654C10.4787 6.35368 10.6044 6.30111 10.7358 6.30018C10.8671 6.29925 10.9936 6.35003 11.0878 6.44156L11.4315 6.78531C11.4782 6.83166 11.5154 6.88678 11.5407 6.94751C11.5661 7.00824 11.5793 7.07339 11.5794 7.13921C11.5795 7.20503 11.5667 7.27023 11.5416 7.33107C11.5165 7.39191 11.4796 7.44719 11.4331 7.49375L11.4315 7.49219ZM12.8199 8.88406C12.7735 8.9305 12.7184 8.96734 12.6577 8.99248C12.597 9.01761 12.532 9.03055 12.4663 9.03055C12.4007 9.03055 12.3356 9.01761 12.275 8.99248C12.2143 8.96734 12.1592 8.9305 12.1128 8.88406L11.7553 8.52469C11.7078 8.47839 11.6701 8.42314 11.6442 8.36213C11.6184 8.30112 11.6049 8.23558 11.6045 8.16931C11.6042 8.10304 11.6171 8.03737 11.6424 7.97612C11.6677 7.91487 11.7049 7.85925 11.7518 7.81251C11.7988 7.76577 11.8546 7.72883 11.916 7.70384C11.9774 7.67885 12.0431 7.66631 12.1094 7.66695C12.1756 7.66758 12.2411 7.68139 12.302 7.70756C12.3629 7.73372 12.4179 7.77173 12.464 7.81937L12.8218 8.17844C12.8682 8.22489 12.905 8.28003 12.9302 8.34071C12.9553 8.40139 12.9682 8.46642 12.9681 8.53209C12.9681 8.59777 12.9551 8.66279 12.93 8.72345C12.9048 8.78411 12.868 8.83921 12.8215 8.88562L12.8199 8.88406Z"
                      fill="#3AB54A"
                    />
                  </Svg>
                </View>
              </View>
              <View style={[styles.mt6, styles.blockAddress, styles.mt3]}>
                <View style={[styles.flex, styles.gap4, styles.mt3]}>
                  <Svg width="12" height="10" viewBox="0 0 10 10">
                    <Path
                      d="M9.99944 7.45556V9.42C9.99951 9.56065 9.94622 9.6961 9.85034 9.799C9.75445 9.9019 9.62311 9.9646 9.48281 9.97445C9.24004 9.99111 9.04172 10 8.8884 10C3.97922 10 0 6.02056 0 1.11111C0 0.957778 0.00833287 0.759445 0.0255541 0.516667C0.0353994 0.376358 0.0980952 0.245006 0.200991 0.149116C0.303886 0.053226 0.439322 -6.3574e-05 0.579968 1.42544e-07H2.5443C2.61321 -6.96303e-05 2.67968 0.0254772 2.73081 0.071678C2.78193 0.117879 2.81406 0.181435 2.82095 0.25C2.83373 0.377778 2.8454 0.479445 2.85651 0.556667C2.96691 1.32718 3.19316 2.07657 3.52758 2.77944C3.58036 2.89056 3.54591 3.02333 3.44592 3.09444L2.2471 3.95111C2.98009 5.65914 4.34117 7.0203 6.04911 7.75333L6.90462 6.55667C6.93958 6.50778 6.9906 6.47271 7.04877 6.45758C7.10694 6.44246 7.16858 6.44823 7.22293 6.47389C7.92567 6.80773 8.67483 7.03343 9.44503 7.14333C9.52225 7.15444 9.62391 7.16611 9.75057 7.17889C9.81903 7.18591 9.88245 7.2181 9.92853 7.26921C9.97462 7.32033 9.99953 7.38673 9.99944 7.45556Z"
                      fill="#647C8F"
                    />
                  </Svg>
                  {!isOrder ? (
                    <Text style={[styles.textNormal, styles.textBlue]}>
                      {dataCustomerBooking?.company?.phone
                        ? dataCustomerBooking?.company?.phone
                        : listBooking?.schedule?.company_info?.phone ?? listBookingDetail?.company?.phone}
                    </Text>
                  ) : (
                    <Text style={[styles.textNormal, styles.textBlue]}>{listOrder?.company?.phone}</Text>
                  )}
                </View>
                <View style={[styles.flex, styles.gap4, styles.mt5, styles.pr5]}>
                  <Svg width="12" height="10" viewBox="0 0 12 16">
                    <Path
                      d="M7 0.5C5.343 0.501843 3.75442 1.12329 2.58274 2.22801C1.41107 3.33274 0.751959 4.83054 0.750004 6.39286C0.74848 7.66951 1.19075 8.91146 2.00909 9.92857C2.00909 9.92857 2.17955 10.1402 2.20739 10.1707L7 15.5L11.7949 10.168C11.8199 10.1396 11.9909 9.92857 11.9909 9.92857L11.9915 9.92696C12.8093 8.91023 13.2513 7.6689 13.25 6.39286C13.248 4.83054 12.5889 3.33274 11.4173 2.22801C10.2456 1.12329 8.657 0.501843 7 0.5ZM7 8.53571C6.5505 8.53571 6.11109 8.41004 5.73734 8.17458C5.36359 7.93912 5.07229 7.60445 4.90028 7.21289C4.72826 6.82134 4.68325 6.39048 4.77094 5.97481C4.85864 5.55913 5.07509 5.17731 5.39294 4.87763C5.71079 4.57794 6.11575 4.37386 6.55661 4.29117C6.99748 4.20849 7.45445 4.25093 7.86973 4.41312C8.28502 4.5753 8.63997 4.84996 8.8897 5.20235C9.13943 5.55474 9.27273 5.96904 9.27273 6.39286C9.27197 6.96096 9.03229 7.50559 8.60623 7.9073C8.18017 8.30901 7.60253 8.53501 7 8.53571Z"
                      fill="#647C8F"
                    />
                  </Svg>
                  {!isOrder ? (
                    <Text style={[styles.textNormal, styles.textBlue]}>
                      {dataCustomerBooking?.company?.representative_office
                        ? dataCustomerBooking?.company?.representative_office
                        : listBooking?.schedule?.company_info?.representative_office ??
                          listBooking?.schedule?.company_info?.address ??
                          listBookingDetail?.company?.address}
                    </Text>
                  ) : (
                    <Text style={[styles.textNormal, styles.textBlue]}>
                      {listOrder?.company?.representative_name ??
                        listOrder?.company?.address ??
                        listBookingDetail?.company?.address}
                    </Text>
                  )}
                </View>
              </View>
              {!isOrder ? (
                <View style={[styles.locationText]}>
                  <Text>
                    {dataCustomerBooking?.route?.depart_point
                      ? dataCustomerBooking?.route?.depart_point
                      : listBookingDetail?.start_location}
                  </Text>
                  <Text>
                    {dataCustomerBooking?.route?.arrive_point
                      ? dataCustomerBooking?.route?.arrive_point
                      : listBookingDetail?.end_location}
                  </Text>
                </View>
              ) : (
                <View style={[styles.locationText]}>
                  <Text>{listOrder?.route?.depart_point}</Text>
                  <Text>{listOrder?.route?.arrive_point}</Text>
                </View>
              )}
              {!isOrder ? (
                <View style={[styles.mt5, styles.flex, styles.iconBusBlock]}>
                  <Image src={iconLeft} style={styles.iconBus} />
                  <Text style={[styles.mt6, styles.hour]}>
                    {listBookingDetail?.time?.duration
                      ? listBookingDetail?.time?.duration
                      : dataCustomerBooking?.travel_time
                      ? dataCustomerBooking?.travel_time
                      : convertTimeBus(listBooking?.schedule?.travel_time)}
                  </Text>
                  <Image src={iconRight} style={styles.iconBus} />
                </View>
              ) : (
                <View style={[styles.mt5, styles.flex, styles.iconBusBlock]}>
                  <Image src={iconLeft} style={styles.iconBus} />
                  <Text style={[styles.mt6, styles.hour]}>{convertMinutes(listOrder?.travel_time)}</Text>
                  <Image src={iconRight} style={styles.iconBus} />
                </View>
              )}

              {!isOrder ? (
                <View style={styles.scheduleBlock}>
                  <View>
                    <Text style={[styles.fs20, styles.fw700]}>
                      {listBookingDetail?.time?.depart_time
                        ? convertTimeFormat(listBookingDetail?.time?.depart_time)
                        : convertTimeFormat(listBooking?.schedule?.depart_time)}
                    </Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {listBookingDetail?.time?.depart_time
                        ? formatDate(listBookingDetail?.time?.depart_date, 'DD/MM/YYYY')
                        : formatDate(listBooking?.schedule?.depart_date, 'DD/MM/YYYY')}
                    </Text>
                  </View>
                  <View style={[styles.arriveBlock]}>
                    <Text style={[styles.fs20, styles.fw700, styles.ml8]}>
                      {listBookingDetail?.time?.arrive_time
                        ? convertTimeFormat(listBookingDetail?.time?.arrive_time)
                        : convertTimeFormat(listBooking?.schedule?.arrive_time)}
                    </Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {listBookingDetail?.time?.arrive_date
                        ? formatDate(listBookingDetail?.time?.arrive_date, 'DD/MM/YYYY')
                        : formatDate(listBooking?.schedule?.arrive_time, 'DD/MM/YYYY')}
                    </Text>
                  </View>
                </View>
              ) : (
                <View style={styles.scheduleBlock}>
                  <View>
                    <Text style={[styles.fs20, styles.fw700]}>{convertTimeFormat(listOrder?.depart_time)}</Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {formatDate(listOrder?.depart_date, 'DD/MM/YYYY')}
                    </Text>
                  </View>
                  <View style={[styles.arriveBlock]}>
                    <Text style={[styles.fs20, styles.fw700, styles.ml8]}>
                      {convertTimeFormat(listOrder?.arrive_time)}
                    </Text>
                    <Text style={[styles.textBlue, styles.fw500, styles.fs12, styles.mt2]}>
                      {formatDate(listOrder?.arrive_date, 'DD/MM/YYYY')}
                    </Text>
                  </View>
                </View>
              )}
              {!isOrder ? (
                <View style={[styles.flex, styles.mt5]}>
                  <Text style={[styles.fs12, styles.fw500]}> {`Loại xe: `}</Text>
                  <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>
                    {listBooking?.schedule?.bus_type?.name ?? listBookingDetail?.bus_type}
                  </Text>
                </View>
              ) : (
                <View style={[styles.flex, styles.mt5]}>
                  <Text style={[styles.fs12, styles.fw500]}> {`Loại xe: `}</Text>
                  <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>{listOrder?.bus_type}</Text>
                </View>
              )}
              {!isOrder ? (
                <View style={[styles.flex, styles.mt5]}>
                  <View style={[styles.flex, styles.w40]}>
                    <Text style={[styles.fs12, styles.fw500]}> {'Mã ghế: '}</Text>
                    <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>{` ${
                      listBookingDetail?.seat_number ?? ''
                    }`}</Text>
                  </View>
                  {listBookingDetail?.display_price ? (
                    <View style={[styles.flex, styles.w60, styles.flexEnd]}>
                      <Text style={[styles.fs12, styles.fw500]}> Tổng tiền: </Text>
                      <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>
                        {listBookingDetail?.price ? ` ${listBookingDetail?.price}VNĐ` : ' 0VNĐ'}
                      </Text>
                    </View>
                  ) : (
                    ''
                  )}
                </View>
              ) : (
                <View style={[styles.flex, styles.mt5]}>
                  <View style={[styles.flex, styles.w40]}>
                    <Text style={[styles.fs12, styles.fw500]}> {'Mã ghế: '}</Text>
                    <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>{` ${
                      listOrder?.seat_number ?? ''
                    }`}</Text>
                  </View>
                  {listOrder?.display_price ? (
                    <View style={[styles.flex, styles.w60, styles.flexEnd]}>
                      <Text style={[styles.fs12, styles.fw500]}> Tổng tiền: </Text>
                      <Text style={[styles.fs12, styles.fw600, styles.textBlue]}>
                        {listOrder?.price ? ` ${formattedPrice(listOrder?.price)}VNĐ` : ' 0VNĐ'}
                      </Text>
                    </View>
                  ) : (
                    ''
                  )}
                </View>
              )}
              {!isOrder ? (
                <View style={[styles.mt5, styles.pb]}>
                  {listBookingDetail?.insurance_fee && <View>{getInsuranceFee()}</View>}
                </View>
              ) : (
                <View style={[styles.mt5, styles.pb]}>
                  {listOrder?.is_insurance && <View>{getInsuranceFee()}</View>}
                </View>
              )}
              {!isOrder ? (
                <View style={[styles.mt7]}>
                  {listBookingDetail?.payment_method === 'reserve' && (
                    <Text style={styles.textWarn}>
                      {`Vui lòng thanh toán trước ${convertTimeFormat(
                        listBooking?.schedule?.depart_time,
                      )} -  ${formatDate(listBooking?.travel_info?.depart_date, 'DD/MM/YYYY')}.`}
                    </Text>
                  )}
                </View>
              ) : (
                ''
              )}
              {!isOrder ? (
                <View style={styles.mt16}>
                  <Text style={[styles.fs12, styles.fw500]}>Hành khách:</Text>
                  <View style={[styles.flex, styles.fs14, styles.textBlue, styles.fw600, styles.mt3]}>
                    <Text>{listBookingDetail?.customer?.name ?? ''}</Text>
                    <View style={[styles.ml8, styles.flex]}>
                      <Svg width="12" height="10" viewBox="0 0 10 10">
                        <Path
                          d="M9.99944 7.45556V9.42C9.99951 9.56065 9.94622 9.6961 9.85034 9.799C9.75445 9.9019 9.62311 9.9646 9.48281 9.97445C9.24004 9.99111 9.04172 10 8.8884 10C3.97922 10 0 6.02056 0 1.11111C0 0.957778 0.00833287 0.759445 0.0255541 0.516667C0.0353994 0.376358 0.0980952 0.245006 0.200991 0.149116C0.303886 0.053226 0.439322 -6.3574e-05 0.579968 1.42544e-07H2.5443C2.61321 -6.96303e-05 2.67968 0.0254772 2.73081 0.071678C2.78193 0.117879 2.81406 0.181435 2.82095 0.25C2.83373 0.377778 2.8454 0.479445 2.85651 0.556667C2.96691 1.32718 3.19316 2.07657 3.52758 2.77944C3.58036 2.89056 3.54591 3.02333 3.44592 3.09444L2.2471 3.95111C2.98009 5.65914 4.34117 7.0203 6.04911 7.75333L6.90462 6.55667C6.93958 6.50778 6.9906 6.47271 7.04877 6.45758C7.10694 6.44246 7.16858 6.44823 7.22293 6.47389C7.92567 6.80773 8.67483 7.03343 9.44503 7.14333C9.52225 7.15444 9.62391 7.16611 9.75057 7.17889C9.81903 7.18591 9.88245 7.2181 9.92853 7.26921C9.97462 7.32033 9.99953 7.38673 9.99944 7.45556Z"
                          fill="#647C8F"
                        />
                      </Svg>
                      <Text style={[styles.textNormal]}>
                        {dataCustomerBooking?.customer?.phone
                          ? ` ${listBookingDetail?.customer?.phone}`
                          : ` ${listBookingDetail?.customer?.phone}`}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles.mt7]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm đón:</Text>
                    {listBookingDetail?.pickup_extra ||
                    !listBookingDetail?.pickup_location?.latitude ||
                    !listBookingDetail?.pickup_location?.longitude ? (
                      <View>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listBookingDetail?.pickup_location?.location_name ?? listBookingDetail?.pickup_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.pickup_location?.address
                            ? `${listBookingDetail?.pickup_location?.address}`
                            : ''}
                        </Text>
                      </View>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${listBookingDetail?.pickup_location?.longitude},${listBookingDetail?.pickup_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.ml6]}>
                          {listBookingDetail?.pickup_location?.location_name ?? listBookingDetail?.pickup_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.pickup_location?.address
                            ? `${listBookingDetail?.pickup_location?.address}`
                            : ''}
                        </Text>
                      </Link>
                    )}
                    <Text style={[styles.hourLocation, styles.mt2]}>
                      {convertTimeFormat(listBookingDetail?.pickup_location?.time)
                        ? ` ${convertTimeFormat(listBookingDetail?.pickup_location?.time)} - ${getDepartDate()}`
                        : ` ${convertTimeFormat(listBooking?.schedule?.depart_time)}- ${getDepartDate()}`}
                    </Text>
                  </View>
                  <View style={[styles.mt5]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm trả:</Text>
                    {listBookingDetail?.drop_off_extra ||
                    !listBookingDetail?.drop_off_location?.latitude ||
                    !listBookingDetail?.drop_off_location?.longitude ? (
                      <>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listBookingDetail?.drop_off_location?.location_name ?? listBookingDetail?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.drop_off_location?.address
                            ? `(${listBookingDetail?.drop_off_location?.address})`
                            : ''}
                        </Text>
                      </>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${listBookingDetail?.drop_off_location?.longitude},${listBookingDetail?.drop_off_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listBookingDetail?.drop_off_location?.location_name ?? listBookingDetail?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.drop_off_location?.address
                            ? `${listBookingDetail?.drop_off_location?.address}`
                            : ''}
                        </Text>
                      </Link>
                    )}
                  </View>
                  <View style={[styles.mt5, styles.flex]}>
                    <Text style={[styles.hourLocation]}>
                      {convertTimeFormat(listBookingDetail?.drop_off_location?.time)
                        ? ` ${convertTimeFormat(listBookingDetail?.drop_off_location?.time)} - ${getArriveDate()}`
                        : ` ${convertTimeFormat(listBooking?.schedule?.arrive_time)}- ${getArriveDate()}`}
                    </Text>
                  </View>
                  <Text style={[styles.fs12, styles.mt7, styles.fw500, styles.pb]}>
                    {'Nhân viên in vé: '}
                    <Text style={[styles.fw600, styles.textBlue]}>{listBookingDetail?.orderer?.name}</Text>
                  </Text>
                </View>
              ) : (
                <View style={styles.mt16}>
                  <Text style={[styles.fs12, styles.fw500]}>Hành khách:</Text>
                  <View style={[styles.flex, styles.fs14, styles.textBlue, styles.fw600, styles.mt3]}>
                    <Text>{listOrder?.customer?.name ?? ''}</Text>
                    <View style={[styles.ml8, styles.flex]}>
                      <Svg width="12" height="10" viewBox="0 0 10 10">
                        <Path
                          d="M9.99944 7.45556V9.42C9.99951 9.56065 9.94622 9.6961 9.85034 9.799C9.75445 9.9019 9.62311 9.9646 9.48281 9.97445C9.24004 9.99111 9.04172 10 8.8884 10C3.97922 10 0 6.02056 0 1.11111C0 0.957778 0.00833287 0.759445 0.0255541 0.516667C0.0353994 0.376358 0.0980952 0.245006 0.200991 0.149116C0.303886 0.053226 0.439322 -6.3574e-05 0.579968 1.42544e-07H2.5443C2.61321 -6.96303e-05 2.67968 0.0254772 2.73081 0.071678C2.78193 0.117879 2.81406 0.181435 2.82095 0.25C2.83373 0.377778 2.8454 0.479445 2.85651 0.556667C2.96691 1.32718 3.19316 2.07657 3.52758 2.77944C3.58036 2.89056 3.54591 3.02333 3.44592 3.09444L2.2471 3.95111C2.98009 5.65914 4.34117 7.0203 6.04911 7.75333L6.90462 6.55667C6.93958 6.50778 6.9906 6.47271 7.04877 6.45758C7.10694 6.44246 7.16858 6.44823 7.22293 6.47389C7.92567 6.80773 8.67483 7.03343 9.44503 7.14333C9.52225 7.15444 9.62391 7.16611 9.75057 7.17889C9.81903 7.18591 9.88245 7.2181 9.92853 7.26921C9.97462 7.32033 9.99953 7.38673 9.99944 7.45556Z"
                          fill="#647C8F"
                        />
                      </Svg>
                      <Text style={[styles.textNormal]}>{listOrder?.customer?.phone}</Text>
                    </View>
                  </View>
                  <View style={[styles.mt7]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm đón:</Text>
                    {listOrder?.pickup_extra ||
                    !listOrder?.pickup_location?.latitude ||
                    !listOrder?.pickup_location?.longitude ? (
                      <>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listOrder?.pickup_location?.location_name ?? listOrder?.pickup_extra}
                        </Text>
                        <Text style={[styles?.fs12, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.pickup_location?.address
                            ? `${listBookingDetail?.pickup_location?.address}`
                            : ''}
                        </Text>
                      </>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${listOrder?.pickup_location?.longitude},${listOrder?.pickup_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.ml6]}>
                          {listOrder?.pickup_location?.location_name ?? listOrder?.pickup_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.pickup_location?.address
                            ? `${listBookingDetail?.pickup_location?.address}`
                            : ''}
                        </Text>
                      </Link>
                    )}
                    <Text style={[styles.hourLocation, styles.mt2]}>
                      {`${convertTimeFormat(listOrder?.pickup_location?.time)} - ${getDepartDate()}`}
                    </Text>
                  </View>
                  <View style={[styles.mt5]}>
                    <Text style={[styles.fs12, styles.fw500]}>Điểm trả:</Text>
                    {listOrder?.drop_off_extra ||
                    !listOrder?.drop_off_location?.latitude ||
                    !listOrder?.drop_off_location?.longitude ? (
                      <>
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listOrder?.drop_off_location?.location_name ?? listOrder?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.drop_off_location?.address
                            ? `${listBookingDetail?.drop_off_location?.address}`
                            : ''}
                        </Text>
                      </>
                    ) : (
                      <Link
                        src={`https://maps.google.com?q=${listOrder?.drop_off_location?.longitude},${listOrder?.drop_off_location?.latitude}`}
                      >
                        <Text style={[styles.fs12, styles.fw600, styles.textBlue, styles.mt2]}>
                          {listOrder?.drop_off_location?.location_name ?? listOrder?.drop_off_extra}
                        </Text>
                        <Text style={[styles.fs10, styles.fw400, styles.textBlue]}>
                          {listBookingDetail?.drop_off_location?.address
                            ? `${listBookingDetail?.drop_off_location?.address}`
                            : ''}
                        </Text>
                      </Link>
                    )}
                  </View>
                  <View style={[styles.mt5, styles.flex]}>
                    <Text style={[styles.hourLocation]}>
                      {` ${convertTimeFormat(listOrder?.drop_off_location?.time)} - ${getArriveDate()}`}
                    </Text>
                  </View>
                  <Text style={[styles.fs12, styles.mt7, styles.fw500, styles.pb]}>
                    {'Nhân viên in vé: '}
                    <Text style={[styles.fw600, styles.textBlue]}>{listOrder?.payer}</Text>
                  </Text>
                </View>
              )}
              {(listBookingDetail?.payment_method === 'hold' ||
                listBookingDetail?.payment_method === 'reserve' ||
                listBookingDetail?.payment_method === 'paid_at_company') &&
              !isOrder ? (
                <View style={styles.qrPayBlock}>
                  <>
                    <View>
                      <Text style={[styles.fs12, styles.fw600, styles.textBlack]}>Thông tin thanh toán</Text>
                      <Text style={[styles.fs12, styles.fw500, styles.mt5]}>
                        Chủ TK:
                        <Text style={[styles.fw600, styles.fs12, styles.textBlue]}>
                          {listBooking?.schedule?.company?.bank_account_name ??
                            listBookingDetail?.company?.bank_account_name}
                        </Text>
                      </Text>
                      <Text style={[styles.fs12, styles.fw500, styles.mt5]}>
                        Số TK:
                        <Text style={[styles.fw600, styles.fs12, styles.textBlue]}>
                          {listBooking?.schedule?.company?.bank_account_number ??
                            listBookingDetail?.company?.bank_account_number}
                        </Text>
                      </Text>
                      <Text style={[styles.fs12, styles.fw500, styles.mt5]}>Nội dung chuyển khoản:</Text>
                      <Text style={[styles.fw600, styles.fs12, styles.textBlue, styles.mt5]}>{`  ${
                        listBookingDetail?.ticket_code
                      }  ${convertName(listBookingDetail?.customer?.name)}`}</Text>
                    </View>
                  </>
                  {listBooking?.schedule?.company?.bank && listBooking?.schedule?.company?.bank_account_number && (
                    <View>
                      {renderQr(
                        `https://img.vietqr.io/image/${listBooking?.schedule?.company?.bank}-${
                          listBooking?.schedule?.company?.bank_account_number
                        }-compact.jpg?amount=${convertPrice(listBookingDetail?.price)}&addInfo=${
                          listBookingDetail?.customer?.name
                        } - ${listBookingDetail?.ticket_code}`,
                      )}
                    </View>
                  )}
                </View>
              ) : !isOrder ? (
                <View style={styles.mt16}>
                  {listBooking?.policy?.cancel_policy?.range?.length && (
                    <Text style={[styles.fs12, styles.fw600, styles.textBlack]}>Chính sách huỷ vé và hoàn trả:</Text>
                  )}
                  {listBooking?.policy?.cancel_policy?.range.map((policy: any, index: any) => {
                    if (index === 0) {
                      return (
                        <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                          Trong vòng {policy?.before_departure_hour} {'trước giờ khởi hành: '}
                          {policy?.cancel_fee_percent ?? 0}%
                        </Text>
                      );
                    } else {
                      const previousPolicy = listBooking?.policy?.cancel_policy?.range[index - 1];
                      return (
                        <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                          Từ {previousPolicy.before_departure_hour} - {policy.before_departure_hour}
                          {' tiếng trước giờ khởi hành: '} {policy?.cancel_fee_percent ?? 0}%
                        </Text>
                      );
                    }
                  })}
                  <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt16]}>
                    Mọi thao tác thay đổi, hoàn hủy vui lòng liên hệ
                  </Text>
                  <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                    đến số hotline nhà xe: .
                  </Text>
                </View>
              ) : (
                ''
              )}
              {isOrder ? (
                <View style={styles.mt16}>
                  {listOrder?.policy?.cancel_policy?.range?.length && (
                    <Text style={[styles.fs12, styles.fw600, styles.textBlack]}>Chính sách huỷ vé và hoàn trả:</Text>
                  )}
                  {listOrder?.policy?.cancel_policy?.range.map((policy: any, index: any) => {
                    if (index === 0) {
                      return (
                        <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                          Trong vòng {policy?.before_departure_hour} {'trước giờ khởi hành: '}
                          {policy?.cancel_fee_percent ?? 0}%
                        </Text>
                      );
                    } else {
                      const previousPolicy = listOrder?.policy?.cancel_policy?.range[index - 1];
                      return (
                        <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                          Từ {previousPolicy.before_departure_hour} - {policy.before_departure_hour}
                          {' tiếng trước giờ khởi hành: '} {policy?.cancel_fee_percent ?? 0}%
                        </Text>
                      );
                    }
                  })}
                  <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt16]}>
                    Mọi thao tác thay đổi, hoàn hủy vui lòng liên hệ
                  </Text>
                  <Text style={[styles.fs12, styles.fw500, styles.textBlack, styles.mt5]}>
                    đến số hotline nhà xe: .
                  </Text>
                </View>
              ) : (
                ''
              )}
              <View style={[styles.footer]}>
                <Text style={[styles.fs12, styles.fw500, styles.gray]}>Vé được xuất bởi hệ thống</Text>
                <View style={[styles.flex, styles.flexCenter, styles.mt3]}>
                  <Image src={iconLogo} style={styles.logoCarlink} />
                  <Text style={[styles.fs12, styles.fw500, styles.green]}>{' carlink.com.vn'}</Text>
                </View>
              </View>
            </View>
          </Page>
        )}
      </Document>
    </>
  );
};
